export default {
      id: "sortArrowUp-usage",
      viewBox: "0 0 10 5",
      url: "assets/" + "sprite.svg#sortArrowUp-usage",
      toString: function () {
        return this.url;
      }
    }